import { v4 as uuid } from 'uuid';
import ImageSettings from '../BlockComponentSettings/ImageSettings';
import BlockComponentValue from './BlockComponentValue';
import LinkData from '../LinkData';

class BlockComponentImage implements BlockComponentValue {
  settings: ImageSettings;
  value?: string;
  alt?: string;
  link?: LinkData;
  solidColor?: string;
  uniqueId?: string;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockComponentImage {
  export function make(url: string, settings?: ImageSettings, alt?: string, link?: LinkData): BlockComponentImage {
    return {
      settings: settings || ImageSettings.getDefault(),
      value: url,
      alt,
      link: link || LinkData.getDefault(),
      uniqueId: uuid(),
    };
  }
}

export default BlockComponentImage;
